import { Field } from "formik";
import { Form } from "react-bootstrap";
import { GroupTitle } from "../../../../StyledComponents";
import * as Yup from "yup";
// SubForms
import { SalutationSubForm, Schema as SalutationSchema } from '../subforms/Salutation';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { DateOfBirthOptionalSubForm,Schema as DateOfBirthOptionalSchema } from '../subforms/DateOfBirthOptional';
import { PersonalDataSubForm, Schema as PersonalDataSchema } from '../subforms/PersonalData';
import { NationalitySubForm } from '../subforms/Nationality';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { AreaOfDeploymentSubForm, Schema as AreaOfDeploymentSchema } from '../subforms/AreaOfDeployment';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const InitiativbewerbungSchema = (settings) => (
    Yup.object()
        .concat(SalutationSchema)
        .concat(NameAndContactSchema(settings))
        .concat(PersonalDataSchema)
        .concat(DateOfBirthOptionalSchema)
        .concat(OtherInformationSchema(settings))
        .concat(AreaOfDeploymentSchema(settings))
        .concat(DocumentsSchema(settings))
);

export const Initiativbewerbung = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <GroupTitle>Kontaktdaten</GroupTitle>
            <Field component={SalutationSubForm} colors={colors} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <GroupTitle>Persönliche Daten</GroupTitle>
            <Field component={DateOfBirthOptionalSubForm} colors={colors} settings={settings} />
            <Field component={PersonalDataSubForm} colors={colors} settings={settings} />
            <Field component={NationalitySubForm} colors={colors} settings={settings} />
            <GroupTitle>Sonstiges</GroupTitle>
            <Field component={OtherInformationSubForm} colors={colors} />
            <Field component={AreaOfDeploymentSubForm} colors={colors} settings={settings} />
            <GroupTitle>Dokumente</GroupTitle>
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}